export type LegalSection = { id: string; heading: string; paragraphs: string[]; bullets?: string[] };
export type LegalDoc = { eyebrow: string; title: string; updated: string; intro: string; sections: LegalSection[] };

const UPDATED = "junho de 2026";
const EMAIL = "support@playshub.net";

export const privacidade: LegalDoc = {
  eyebrow: "RGPD · Portugal",
  title: "Política de Privacidade",
  updated: UPDATED,
  intro:
    "Esta Política de Privacidade explica como a PLAYS / Possibilidade recolhe, utiliza e protege os dados pessoais dos visitantes do sítio playshub.net, em conformidade com o Regulamento (UE) 2016/679 (RGPD) e a Lei n.º 58/2019, de 8 de agosto.",
  sections: [
    {
      id: "responsavel",
      heading: "Responsável pelo tratamento",
      paragraphs: [
        `A entidade responsável pelo tratamento dos dados pessoais recolhidos através do sítio playshub.net é a PLAYS / Possibilidade (doravante "PLAYS" ou "nós"). Para qualquer questão relacionada com a proteção de dados, pode contactar-nos através do endereço de correio eletrónico ${EMAIL}.`,
      ],
    },
    {
      id: "dados",
      heading: "Dados pessoais que recolhemos",
      paragraphs: ["O sítio é, nesta fase, um sítio informativo. Recolhemos apenas os dados estritamente necessários:"],
      bullets: [
        "Dados de contacto que nos envia voluntariamente por correio eletrónico (nome, endereço de email e conteúdo da mensagem). O sítio não tem formulários nem base de dados de utilizadores.",
        "Dados técnicos de navegação tratados pela nossa infraestrutura (endereço IP, tipo de navegador, sistema operativo, páginas visitadas, data e hora do acesso).",
        "Dados de utilização recolhidos através de cookies analíticos (PostHog), apenas se o utilizador der o seu consentimento.",
      ],
    },
    {
      id: "finalidades",
      heading: "Finalidades e fundamentos de licitude",
      paragraphs: ["Tratamos os seus dados pessoais para as seguintes finalidades e com os seguintes fundamentos jurídicos:"],
      bullets: [
        "Responder a pedidos de contacto e informação — diligências pré-contratuais e interesse legítimo (art. 6.º, n.º 1, al. b) e f) do RGPD).",
        "Garantir a segurança, disponibilidade e desempenho do sítio — interesse legítimo (art. 6.º, n.º 1, al. f)).",
        "Analisar de forma agregada a utilização do sítio para o melhorar — consentimento (art. 6.º, n.º 1, al. a)), prestado através do banner de cookies.",
        "Cumprir obrigações legais a que estejamos sujeitos (art. 6.º, n.º 1, al. c)).",
      ],
    },
    {
      id: "cookies",
      heading: "Cookies e tecnologias semelhantes",
      paragraphs: [
        "Quando visita o sítio pela primeira vez é apresentado um banner de consentimento. Os cookies analíticos só são instalados depois de clicar em “Aceitar”. Se recusar, não é feito qualquer rastreio analítico. A sua escolha fica guardada no seu navegador (armazenamento local) para que não lhe voltemos a perguntar.",
        "Utilizamos as seguintes categorias:",
      ],
      bullets: [
        "Estritamente necessários: guardam a sua preferência de consentimento e asseguram o funcionamento e segurança do sítio. Não requerem consentimento.",
        "Analíticos (PostHog): permitem-nos perceber como o sítio é utilizado (páginas visitadas, cliques, duração da sessão, tipo de dispositivo). Só são ativados com o seu consentimento.",
      ],
    },
    {
      id: "posthog",
      heading: "Analytics — PostHog",
      paragraphs: [
        "Utilizamos o PostHog (PostHog, Inc.) como ferramenta de análise de utilização, configurado para alojar os dados na União Europeia (região EU). O PostHog recolhe eventos de navegação, informação sobre o dispositivo e navegador, e um identificador anónimo gerado aleatoriamente. Não associamos estes dados ao seu nome nem ao seu endereço de correio eletrónico.",
        "O PostHog só é inicializado após o seu consentimento expresso através do banner de cookies. Pode retirar o consentimento em qualquer momento através de “Definições de cookies” no rodapé ou limpando os dados do sítio no seu navegador.",
        "Mais informação: https://posthog.com/privacy.",
      ],
    },
    {
      id: "cloudflare",
      heading: "Infraestrutura e segurança — Cloudflare",
      paragraphs: [
        "O sítio é servido através da rede da Cloudflare, Inc., que presta serviços de distribuição de conteúdos (CDN), DNS e proteção contra ataques (WAF/DDoS). Para prestar estes serviços, a Cloudflare trata dados técnicos de ligação, nomeadamente o endereço IP, cabeçalhos HTTP e informação do navegador, e pode utilizar cookies estritamente necessários para fins de segurança.",
        "Este tratamento é realizado com fundamento no nosso interesse legítimo em garantir a segurança e disponibilidade do sítio. A Cloudflare atua como subcontratante e está vinculada às Cláusulas Contratuais-Tipo aprovadas pela Comissão Europeia e ao Data Privacy Framework UE-EUA. Mais informação: https://www.cloudflare.com/privacypolicy/.",
      ],
    },
    {
      id: "partilha",
      heading: "Partilha de dados com terceiros",
      paragraphs: [
        "Não vendemos nem cedemos os seus dados pessoais. Apenas os partilhamos com os prestadores de serviços referidos nesta política (PostHog e Cloudflare), que atuam por nossa conta e sob as nossas instruções, e com autoridades públicas quando exigido por lei.",
      ],
    },
    {
      id: "transferencias",
      heading: "Transferências internacionais",
      paragraphs: [
        "Sempre que os nossos prestadores de serviços tratem dados fora do Espaço Económico Europeu, asseguramos que existem garantias adequadas nos termos do Capítulo V do RGPD, designadamente Cláusulas Contratuais-Tipo ou uma decisão de adequação da Comissão Europeia.",
      ],
    },
    {
      id: "conservacao",
      heading: "Prazos de conservação",
      paragraphs: ["Conservamos os dados apenas durante o período necessário às finalidades para que foram recolhidos:"],
      bullets: [
        "Emails de contacto: apenas na nossa caixa de correio, até 24 meses após a última interação, salvo obrigação legal em contrário.",
        "Dados analíticos (PostHog): até 12 meses, em forma agregada ou pseudonimizada.",
        "Registos técnicos de segurança (Cloudflare): pelos prazos definidos pelo prestador, tipicamente inferiores a 30 dias.",
        "Preferência de consentimento: até 12 meses ou até ser apagada do navegador.",
      ],
    },
    {
      id: "direitos",
      heading: "Os seus direitos",
      paragraphs: ["Nos termos do RGPD, tem o direito de:"],
      bullets: [
        "Aceder aos seus dados pessoais e obter uma cópia dos mesmos.",
        "Solicitar a retificação de dados inexatos ou incompletos.",
        "Solicitar o apagamento dos seus dados (“direito a ser esquecido”).",
        "Solicitar a limitação do tratamento e opor-se ao tratamento.",
        "Receber os seus dados num formato estruturado e de uso corrente (portabilidade).",
        "Retirar o consentimento a qualquer momento, sem comprometer a licitude do tratamento efetuado até essa data.",
      ],
    },
    {
      id: "exercicio",
      heading: "Como exercer os seus direitos e reclamar",
      paragraphs: [
        `Para exercer qualquer destes direitos, contacte-nos através de ${EMAIL}. Responderemos no prazo máximo de um mês, prorrogável nos termos da lei. Tem ainda o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD) — Av. D. Carlos I, 134, 1.º, 1200-651 Lisboa — www.cnpd.pt.`,
      ],
    },
    {
      id: "seguranca",
      heading: "Segurança",
      paragraphs: [
        "Adotamos medidas técnicas e organizativas adequadas para proteger os seus dados contra acesso não autorizado, perda, alteração ou divulgação, incluindo encriptação em trânsito (TLS/HTTPS), proteção perimetral através da Cloudflare e controlo de acessos restrito.",
      ],
    },
    {
      id: "menores",
      heading: "Menores",
      paragraphs: [
        "O sítio não se destina a menores de 16 anos e não recolhemos intencionalmente dados pessoais de menores. Se tiver conhecimento de que um menor nos forneceu dados pessoais, contacte-nos para que possamos proceder ao seu apagamento.",
      ],
    },
    {
      id: "alteracoes",
      heading: "Alterações a esta política",
      paragraphs: [
        "Podemos atualizar esta Política de Privacidade para refletir alterações legais, técnicas ou do nosso serviço. A versão em vigor está sempre disponível nesta página, com indicação da data da última atualização.",
      ],
    },
    {
      id: "contacto",
      heading: "Contacto",
      paragraphs: [`Para qualquer questão sobre esta política ou sobre o tratamento dos seus dados pessoais: ${EMAIL}.`],
    },
  ],
};

export const termos: LegalDoc = {
  eyebrow: "Termos legais · Portugal",
  title: "Termos e Condições de Utilização",
  updated: UPDATED,
  intro:
    "Os presentes Termos e Condições regulam o acesso e a utilização do sítio playshub.net e dos conteúdos disponibilizados pela PLAYS / Possibilidade. Ao aceder ao sítio, o utilizador aceita os presentes Termos.",
  sections: [
    {
      id: "aceitacao",
      heading: "Aceitação dos termos",
      paragraphs: [
        "O acesso e a utilização do sítio playshub.net implicam a aceitação plena e sem reservas dos presentes Termos e Condições de Utilização, bem como da Política de Privacidade. Se não concordar com os mesmos, deverá abster-se de utilizar o sítio.",
      ],
    },
    {
      id: "objeto",
      heading: "Objeto e estado de desenvolvimento",
      paragraphs: [
        "O sítio tem carácter informativo e destina-se a apresentar o projeto PLAYS — uma plataforma para a comunidade desportiva (atletas, clubes, organizações, organizadores e fãs) — e a permitir o contacto com a equipa.",
        "A aplicação PLAYS encontra-se em fase de desenvolvimento (“App in development”). As funcionalidades descritas no sítio são indicativas, podem ser alteradas a qualquer momento e não constituem uma oferta contratual nem garantia de disponibilização futura.",
      ],
    },
    {
      id: "utilizacao",
      heading: "Utilização permitida",
      paragraphs: ["O utilizador compromete-se a utilizar o sítio de forma lícita e de acordo com a boa-fé. É expressamente proibido:"],
      bullets: [
        "Utilizar o sítio para fins ilícitos, difamatórios, discriminatórios ou que incitem à violência, nomeadamente no contexto desportivo.",
        "Tentar aceder de forma não autorizada aos sistemas, servidores ou redes associados ao sítio.",
        "Utilizar robôs, scrapers ou outros meios automatizados para extrair conteúdos ou dados sem autorização prévia por escrito.",
        "Reproduzir, modificar ou distribuir conteúdos do sítio fora dos limites previstos nestes Termos.",
      ],
    },
    {
      id: "propriedade",
      heading: "Propriedade intelectual e marcas",
      paragraphs: [
        "Todos os conteúdos do sítio — textos, imagens, grafismos, código-fonte, elementos de design e a sua composição — são protegidos por direitos de autor e direitos conexos, nos termos do Código do Direito de Autor e dos Direitos Conexos e da legislação aplicável.",
        "PLAYS, os respetivos logótipos e identidade visual são propriedade intelectual protegida. É proibida a utilização, reprodução ou distribuição sem autorização expressa. Nenhuma disposição destes Termos confere ao utilizador qualquer licença ou direito sobre estes sinais distintivos.",
        "As imagens de terceiros eventualmente utilizadas no sítio pertencem aos respetivos autores e são utilizadas ao abrigo das licenças aplicáveis.",
      ],
    },
    {
      id: "contacto-email",
      heading: "Contacto e comunicações",
      paragraphs: [
        `O contacto com a PLAYS é efetuado através do endereço ${EMAIL}. Procuramos responder no prazo de 48 horas, sem que tal constitua uma obrigação contratual. As comunicações enviadas não conferem ao utilizador qualquer direito a serviços, funcionalidades ou acesso antecipado à aplicação.`,
      ],
    },
    {
      id: "ligacoes",
      heading: "Ligações e serviços de terceiros",
      paragraphs: [
        "O sítio pode conter ligações para sítios de terceiros e recorre a serviços de terceiros (nomeadamente Cloudflare e PostHog) para o seu funcionamento. A PLAYS não controla nem se responsabiliza pelos conteúdos, políticas ou práticas desses terceiros, cujos termos e políticas de privacidade se aplicam de forma autónoma.",
      ],
    },
    {
      id: "responsabilidade",
      heading: "Garantias e limitação de responsabilidade",
      paragraphs: [
        "O sítio é disponibilizado “tal como está” e “conforme disponível”. A PLAYS envida esforços razoáveis para manter a informação atualizada e o sítio acessível, mas não garante a ausência de erros, interrupções ou indisponibilidades.",
        "Na medida máxima permitida pela lei portuguesa, a PLAYS não é responsável por quaisquer danos diretos ou indiretos decorrentes da utilização ou impossibilidade de utilização do sítio, salvo em caso de dolo ou culpa grave. Nada nestes Termos limita os direitos que a lei confere imperativamente aos consumidores.",
      ],
    },
    {
      id: "privacidade",
      heading: "Proteção de dados",
      paragraphs: [
        "O tratamento de dados pessoais no âmbito da utilização do sítio rege-se pela nossa Política de Privacidade, disponível em /privacidade, que faz parte integrante dos presentes Termos.",
      ],
    },
    {
      id: "alteracoes",
      heading: "Alterações aos termos",
      paragraphs: [
        "A PLAYS reserva-se o direito de alterar os presentes Termos a qualquer momento. As alterações produzem efeitos a partir da sua publicação no sítio, com indicação da data de atualização. A utilização continuada do sítio após a publicação constitui aceitação dos novos Termos.",
      ],
    },
    {
      id: "lei",
      heading: "Lei aplicável e resolução de litígios",
      paragraphs: [
        "Os presentes Termos regem-se pela lei portuguesa. Para a resolução de qualquer litígio emergente da sua interpretação ou execução são competentes os tribunais portugueses, sem prejuízo das normas imperativas de competência aplicáveis aos consumidores.",
        "Em caso de litígio de consumo, o utilizador pode recorrer a uma entidade de resolução alternativa de litígios (RAL). Informação disponível em www.consumidor.gov.pt.",
      ],
    },
    {
      id: "contacto",
      heading: "Contacto",
      paragraphs: [`Para qualquer questão relativa a estes Termos: ${EMAIL}.`],
    },
  ],
};

const UPDATED_EN = "June 2026";

export const privacyEn: LegalDoc = {
  eyebrow: "GDPR · Portugal",
  title: "Privacy Policy",
  updated: UPDATED_EN,
  intro:
    "This Privacy Policy explains how PLAYS collects, uses and protects the personal data of visitors to playshub.net, in accordance with Regulation (EU) 2016/679 (GDPR) and Portuguese Law no. 58/2019 of 8 August.",
  sections: [
    {
      id: "responsavel",
      heading: "Data controller",
      paragraphs: [
        `The entity responsible for processing personal data collected through playshub.net is PLAYS ("PLAYS", "we"). For any data-protection matter you can contact us at ${EMAIL}.`,
      ],
    },
    {
      id: "dados",
      heading: "Personal data we collect",
      paragraphs: ["The site is, at this stage, informational. We collect only the data strictly necessary:"],
      bullets: [
        "Contact data you voluntarily send us by email (name, email address and message content). The site has no forms and no user database.",
        "Technical browsing data processed by our infrastructure (IP address, browser type, operating system, pages visited, date and time of access).",
        "Usage data collected through analytics cookies (PostHog), only if you give your consent.",
      ],
    },
    {
      id: "finalidades",
      heading: "Purposes and legal bases",
      paragraphs: ["We process your personal data for the following purposes and on the following legal bases:"],
      bullets: [
        "Replying to contact and information requests — pre-contractual steps and legitimate interest (Art. 6(1)(b) and (f) GDPR).",
        "Ensuring the security, availability and performance of the site — legitimate interest (Art. 6(1)(f)).",
        "Analysing site usage in aggregate to improve it — consent (Art. 6(1)(a)), given through the cookie banner.",
        "Complying with legal obligations (Art. 6(1)(c)).",
      ],
    },
    {
      id: "cookies",
      heading: "Cookies and similar technologies",
      paragraphs: [
        "When you first visit the site a consent banner is shown. Analytics cookies are only set after you click “Accept”. If you reject, no analytics tracking takes place. Your choice is stored in your browser (local storage) so we do not ask again.",
        "We use the following categories:",
      ],
      bullets: [
        "Strictly necessary: store your consent preference and ensure the site works securely. No consent required.",
        "Analytics (PostHog): help us understand how the site is used (pages visited, clicks, session duration, device type). Only activated with your consent.",
      ],
    },
    {
      id: "posthog",
      heading: "Analytics — PostHog",
      paragraphs: [
        "We use PostHog (PostHog, Inc.) as our analytics tool, configured to host data in the European Union (EU region). PostHog collects navigation events, device and browser information and a randomly generated anonymous identifier. We do not link this data to your name or email address.",
        "PostHog is only initialised after your explicit consent through the cookie banner. You can withdraw consent at any time via “Cookie settings” in the footer or by clearing site data in your browser.",
        "More information: https://posthog.com/privacy.",
      ],
    },
    {
      id: "cloudflare",
      heading: "Infrastructure and security — Cloudflare",
      paragraphs: [
        "The site is served through the network of Cloudflare, Inc., which provides content delivery (CDN), DNS and attack protection (WAF/DDoS). To provide these services Cloudflare processes technical connection data, namely IP address, HTTP headers and browser information, and may use strictly necessary cookies for security purposes.",
        "This processing is based on our legitimate interest in keeping the site secure and available. Cloudflare acts as a processor and is bound by the Standard Contractual Clauses approved by the European Commission and the EU-US Data Privacy Framework. More information: https://www.cloudflare.com/privacypolicy/.",
      ],
    },
    {
      id: "partilha",
      heading: "Sharing with third parties",
      paragraphs: [
        "We do not sell or transfer your personal data. We only share it with the service providers referred to in this policy (PostHog and Cloudflare), who act on our behalf and under our instructions, and with public authorities when required by law.",
      ],
    },
    {
      id: "transferencias",
      heading: "International transfers",
      paragraphs: [
        "Whenever our providers process data outside the European Economic Area we ensure appropriate safeguards under Chapter V of the GDPR, namely Standard Contractual Clauses or an adequacy decision of the European Commission.",
      ],
    },
    {
      id: "conservacao",
      heading: "Retention periods",
      paragraphs: ["We keep data only for as long as necessary for the purposes for which it was collected:"],
      bullets: [
        "Contact emails: only in our mailbox, up to 24 months after the last interaction, unless a legal obligation requires otherwise.",
        "Analytics data (PostHog): up to 12 months, in aggregated or pseudonymised form.",
        "Technical security logs (Cloudflare): for the periods defined by the provider, typically under 30 days.",
        "Consent preference: up to 12 months or until deleted from your browser.",
      ],
    },
    {
      id: "direitos",
      heading: "Your rights",
      paragraphs: ["Under the GDPR you have the right to:"],
      bullets: [
        "Access your personal data and obtain a copy.",
        "Request rectification of inaccurate or incomplete data.",
        "Request erasure of your data (“right to be forgotten”).",
        "Request restriction of processing and object to processing.",
        "Receive your data in a structured, commonly used format (portability).",
        "Withdraw consent at any time, without affecting the lawfulness of processing carried out before withdrawal.",
      ],
    },
    {
      id: "exercicio",
      heading: "Exercising your rights and complaints",
      paragraphs: [
        `To exercise any of these rights, contact us at ${EMAIL}. We will reply within one month, extendable as permitted by law. You also have the right to lodge a complaint with the Portuguese supervisory authority, Comissão Nacional de Proteção de Dados (CNPD) — Av. D. Carlos I, 134, 1.º, 1200-651 Lisboa — www.cnpd.pt.`,
      ],
    },
    {
      id: "seguranca",
      heading: "Security",
      paragraphs: [
        "We adopt appropriate technical and organisational measures to protect your data against unauthorised access, loss, alteration or disclosure, including encryption in transit (TLS/HTTPS), perimeter protection through Cloudflare and restricted access controls.",
      ],
    },
    {
      id: "menores",
      heading: "Minors",
      paragraphs: [
        "The site is not intended for children under 16 and we do not knowingly collect personal data from minors. If you become aware that a minor has provided us with personal data, please contact us so we can delete it.",
      ],
    },
    {
      id: "alteracoes",
      heading: "Changes to this policy",
      paragraphs: [
        "We may update this Privacy Policy to reflect legal, technical or service changes. The current version is always available on this page with the date of the last update.",
      ],
    },
    {
      id: "contacto",
      heading: "Contact",
      paragraphs: [`For any question about this policy or the processing of your personal data: ${EMAIL}.`],
    },
  ],
};

export const termsEn: LegalDoc = {
  eyebrow: "Legal terms · Portugal",
  title: "Terms and Conditions of Use",
  updated: UPDATED_EN,
  intro:
    "These Terms and Conditions govern access to and use of the playshub.net website and the content made available by PLAYS. By accessing the site, you accept these Terms.",
  sections: [
    {
      id: "aceitacao",
      heading: "Acceptance of the terms",
      paragraphs: [
        "Accessing and using playshub.net implies full acceptance of these Terms and Conditions of Use and of the Privacy Policy. If you do not agree with them, please refrain from using the site.",
      ],
    },
    {
      id: "objeto",
      heading: "Purpose and development status",
      paragraphs: [
        "The site is informational and presents the PLAYS project — a platform for the sports community (athletes, clubs, organizations, organizers and fans) — and allows you to contact the team.",
        "The PLAYS app is under development (“App in development”). The features described on the site are indicative, may change at any time and do not constitute a contractual offer or a guarantee of future availability.",
      ],
    },
    {
      id: "utilizacao",
      heading: "Permitted use",
      paragraphs: ["You agree to use the site lawfully and in good faith. It is expressly forbidden to:"],
      bullets: [
        "Use the site for unlawful, defamatory, discriminatory purposes or to incite violence, including in a sporting context.",
        "Attempt unauthorised access to the systems, servers or networks associated with the site.",
        "Use bots, scrapers or other automated means to extract content or data without prior written authorisation.",
        "Reproduce, modify or distribute site content beyond the limits set out in these Terms.",
      ],
    },
    {
      id: "propriedade",
      heading: "Intellectual property and trademarks",
      paragraphs: [
        "All site content — texts, images, graphics, source code, design elements and their arrangement — is protected by copyright and related rights under the Portuguese Code of Copyright and Related Rights and applicable legislation.",
        "PLAYS, os respetivos logótipos e identidade visual são propriedade intelectual protegida. É proibida a utilização, reprodução ou distribuição sem autorização expressa. (PLAYS, its logos and visual identity are protected intellectual property. Use, reproduction or distribution without express authorisation is prohibited.) Nothing in these Terms grants you any licence or right over these distinctive signs.",
        "Third-party images used on the site belong to their respective authors and are used under the applicable licences.",
      ],
    },
    {
      id: "contacto-email",
      heading: "Contact and communications",
      paragraphs: [
        `You can contact PLAYS at ${EMAIL}. We aim to reply within 48 hours on business days, without this constituting a contractual obligation. Messages sent do not grant you any right to services, features or early access to the app.`,
      ],
    },
    {
      id: "ligacoes",
      heading: "Third-party links and services",
      paragraphs: [
        "The site may contain links to third-party websites and relies on third-party services (namely Cloudflare and PostHog) to operate. PLAYS does not control and is not responsible for the content, policies or practices of those third parties, whose own terms and privacy policies apply.",
      ],
    },
    {
      id: "responsabilidade",
      heading: "Warranties and limitation of liability",
      paragraphs: [
        "The site is provided “as is” and “as available”. PLAYS makes reasonable efforts to keep information up to date and the site accessible, but does not guarantee the absence of errors, interruptions or downtime.",
        "To the maximum extent permitted by Portuguese law, PLAYS is not liable for any direct or indirect damages arising from the use or inability to use the site, except in cases of wilful misconduct or gross negligence. Nothing in these Terms limits the rights mandatorily granted to consumers by law.",
      ],
    },
    {
      id: "privacidade",
      heading: "Data protection",
      paragraphs: [
        "The processing of personal data in connection with the use of the site is governed by our Privacy Policy, available at /privacidade, which forms an integral part of these Terms.",
      ],
    },
    {
      id: "alteracoes",
      heading: "Changes to the terms",
      paragraphs: [
        "PLAYS reserves the right to change these Terms at any time. Changes take effect upon publication on the site, with the update date indicated. Continued use of the site after publication constitutes acceptance of the new Terms.",
      ],
    },
    {
      id: "lei",
      heading: "Governing law and disputes",
      paragraphs: [
        "These Terms are governed by Portuguese law. Any dispute arising from their interpretation or performance shall be submitted to the Portuguese courts, without prejudice to mandatory jurisdiction rules applicable to consumers.",
        "In the event of a consumer dispute, you may resort to an alternative dispute resolution (ADR) entity. Information available at www.consumidor.gov.pt.",
      ],
    },
    {
      id: "contacto",
      heading: "Contact",
      paragraphs: [`For any question regarding these Terms: ${EMAIL}.`],
    },
  ],
};
